import { Box } from '@chakra-ui/react';
import { FC } from 'react';
import { Outlet } from 'react-router';

export const ReleasePageView: FC = () => (
  <Box m="0" p="0">
    <Outlet />
  </Box>
);
